import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const AlertSettingsOutlinedSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="18" height="18">
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.73 2h8.54L17 9l-3.73 7H4.73L1 9l3.73-7Zm-2.6 7 3.2-6h7.34l3.2 6-3.2 6H5.33l-3.2-6Z"
        />
    </svg>
)

const AlertSettingsOutlinedIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>{AlertSettingsOutlinedSvg}</SvgIcon>
)

export default AlertSettingsOutlinedIcon
